export { ArchiveLabel } from './ui/ArchiveLabel.main';
